import Texts from './texts'
export default Texts